// Espejo de aws_lambdas/_shared_autoescuela/seccionesApp.js (secciones de la app que el dueño puede ocultar).
// El CUERPO entre las dos marcas es idéntico al canónico (lo fija aws_lambdas/_shared_autoescuela/seccionesAppCopias.test.js):
// se edita allí y se copia con `node aws_lambdas/_shared_autoescuela/seccionesAppCopias.js`. Aquí NO se toca.
// Ficha: docs/features/autoescuela-ocultar-secciones.md
// ── seccionesApp: cuerpo compartido (inicio) ──
// Ocultables. `rutas`: lo que deja de abrirse (y redirige a Planificación); prefijo exacto o subruta.
const SECCIONES_APP = [
  { id: "dashboard", nombre: "Dashboard", para: "El resumen del día: prácticas, sin confirmar, cobros pendientes y próximo examen.", rutas: ["/dashboard"] },
  { id: "chats", nombre: "Chats", para: "Las conversaciones de WhatsApp con tus alumnos. Los avisos automáticos se siguen enviando igual.", rutas: ["/chats", "/chat", "/contactos", "/iniciar-conversacion"] },
  { id: "examenes", nombre: "Exámenes", para: "Apuntar exámenes teóricos y prácticos, sus resultados, la garantía de aprobado y las tasas de la DGT.", rutas: ["/examenes"] },
  { id: "tests", nombre: "Tests de teórica", para: "Tests tipo examen por WhatsApp o Telegram y su pestaña en la ficha del alumno.", rutas: [] },
  { id: "cursos", nombre: "Cursos y CAP", para: "Cursos de CAP, recuperación de puntos o ADR, y el aviso de caducidad del CAP.", rutas: ["/cursos"] },
  { id: "cobros", nombre: "Cobros y facturación", para: "Pagos y saldo de cada alumno, enlaces de pago y facturas.", rutas: ["/pagos", "/facturacion"] },
  { id: "flota", nombre: "Flota", para: "Tus vehículos con su ITV, seguro y mantenimiento, y sus avisos de vencimiento.", rutas: ["/flota"] },
  { id: "fichajes", nombre: "Fichajes", para: "El control horario de tus profesores (entrada y salida).", rutas: ["/fichajes"] },
];
// Nunca se ocultan: sin ellas la app no sirve para lo que se contrata (planificar y avisar).
const SECCIONES_FIJAS = [
  { id: "planificacion", nombre: "Planificación" },
  { id: "alumnos", nombre: "Alumnos" },
  { id: "ajustes", nombre: "Ajustes" },
  { id: "mensajes_automaticos", nombre: "Mensajes automáticos" },
];
const SECCIONES_IDS = SECCIONES_APP.map((s) => s.id);

/** Lo guardado (o basura) → lista de ids conocidos, sin duplicados, en el orden del catálogo. Idempotente. */
function normalizaOcultas(raw) {
  if (!Array.isArray(raw)) return [];
  return SECCIONES_IDS.filter((id) => raw.includes(id));
}

/** Lo que llega al guardar → { value } o { error } (en español, para enseñarlo tal cual). null = mostrar todo. */
function validaOcultas(raw) {
  if (raw === null) return { value: [] };
  if (!Array.isArray(raw)) return { error: "modulos_ocultos debe ser una lista de secciones" };
  for (const id of raw) {
    if (typeof id !== "string") return { error: "modulos_ocultos solo admite nombres de sección" };
    const fija = SECCIONES_FIJAS.find((s) => s.id === id);
    if (fija) return { error: `${fija.nombre} no se puede ocultar` };
    if (!SECCIONES_IDS.includes(id)) return { error: `Sección desconocida: ${id}` };
  }
  return { value: normalizaOcultas(raw) };
}

/** Sección ocultable a la que pertenece una ruta del CRM, o null (las fijas y el resto nunca se tapan). */
function seccionDeRuta(pathname) {
  if (typeof pathname !== "string") return null;
  for (const s of SECCIONES_APP) {
    if (s.rutas.some((r) => pathname === r || pathname.startsWith(r + "/"))) return s.id;
  }
  return null;
}

function seccionVisible(id, ocultas) {
  return !(Array.isArray(ocultas) && ocultas.includes(id));
}

function rutaVisible(pathname, ocultas) {
  const s = seccionDeRuta(pathname);
  return !s || seccionVisible(s, ocultas);
}
// ── seccionesApp: cuerpo compartido (fin) ──

export {
  SECCIONES_APP, SECCIONES_FIJAS, SECCIONES_IDS, normalizaOcultas, validaOcultas, seccionDeRuta, seccionVisible, rutaVisible,
};
